import { render } from "./RegisterVerify.vue?vue&type=template&id=004e6094"
import script from "./RegisterVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterVerify.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/RegisterVerify.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "004e6094"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('004e6094', __exports__)) {
    api.reload('004e6094', __exports__)
  }
  
  module.hot.accept("./RegisterVerify.vue?vue&type=template&id=004e6094", () => {
    api.rerender('004e6094', render)
  })

}


export default __exports__